import React from 'react';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { countryCodes } from '../data/countryCodes';
import { showNotif } from 'utils/notification';
import { FilterItemLocation } from '../components/common/Elements/Elements';
import { listChangedNameFilers } from 'data/listChangedNameFilers';
import { postRequest, putRequest } from 'utils/requests';
import { getExportInstance } from 'utils/jarvisApiClient';
import { env } from 'env';
import { isRegionSwitchStayPath } from 'utils/regionNavigation';
export const filtersRange = ['1-20', '21-40', '41-60', '61-80', '81-100'];

const p81AppDomains = {
  AU: 'au.sase.checkpoint.com',
  US: 'perimeter81.com',
  EU: 'eu.sase.checkpoint.com',
  IN: 'in.sase.checkpoint.com',
  CA: 'ca.sase.checkpoint.com'
};

export const limitCustomersSelect = 251;

export const defaultRegion = 'US';

export const getValueByPercent = (value, percent) => {
  return value * (percent / 100);
};

export const upFirstLetter = word =>
  word ? String(word).replace(/^\w/, m => m.toUpperCase()) : '';

export const underlineToSpace = str => (str ? str.replaceAll('_', ' ') : str);

export const isData = data => {
  return data && data !== 'NA';
};

export const getFullName = (name, surname) => {
  if (isData(name) && isData(surname)) {
    return `${name} ${surname}`;
  }
  if (isData(name)) {
    return name;
  }
  if (isData(surname)) {
    return surname;
  }
  return 'NA';
};

export const getInitials = (name, surname) => {
  if (isData(name) && isData(surname)) {
    return `${name[0].toUpperCase()}${surname[0].toUpperCase()}`;
  }
  if (isData(name)) {
    return name[0].toUpperCase();
  }
  if (isData(surname)) {
    return surname[0].toUpperCase();
  }
  return 'NA';
};

export const getInitialsFull = name => {
  if (name) {
    return name
      .split(' ')
      .map(x => x.charAt(0))
      .join('')
      .substr(0, 2)
      .toUpperCase();
  }
  return 'NA';
};

export const moneyFormater = amount => {
  if (!amount) {
    if (amount === '0' || amount === 0) return amount;
    return 'NA';
  }
  if (amount < 0) amount *= -1;
  if (amount < 100) return `$${amount}`;
  if (amount >= 100 && amount < 1000000)
    return `$${Math.round((amount / 1000 + Number.EPSILON) * 100) / 100}k`;
  if (amount >= 1000000 && amount < 1000000000)
    return `$${Math.round((amount / 1000000 + Number.EPSILON) * 100) / 100}m`;
  if (amount >= 1000000000)
    return `$${
      Math.round((amount / 1000000000 + Number.EPSILON) * 100) / 100
    }b`;
  return amount;
};

export const moneyFormaterFull = (amount, fraction = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fraction
  }).format(amount);
};

export const textToDateMY = text => {
  if (text) {
    const options = { month: 'short', year: 'numeric' };
    const date = new Date(text);
    const newViewDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return newViewDate;
  } else return '';
};

export const textToDateM = (text, type = 's') => {
  if (text) {
    const options = { month: 'short' };
    if (type === 'l') options.month = 'long';
    const date = new Date(text);
    const newViewDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return newViewDate;
  }
  return '';
};

export const textToDate = text => {
  if (text) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const date = new Date(text);
    const newViewDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return newViewDate;
  }
  return '';
};

export const textToDateDMY = (start, end) => {
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const dateStart = start ? new Date(start) : null;
  const dateEnd = end ? new Date(end) : null;
  const newViewDateStart = dateStart
    ? new Intl.DateTimeFormat('en-GB', options).format(dateStart)
    : '';
  const newViewDateEnd = dateEnd
    ? new Intl.DateTimeFormat('en-GB', options).format(dateEnd)
    : '';
  return `${newViewDateStart} - ${newViewDateEnd}`;
};

export const textToTime = text => {
  const options = { hour: 'numeric', minute: 'numeric' };
  const date = new Date(text);
  const newViewTime = new Intl.DateTimeFormat('en-US', options).format(date);
  return newViewTime;
};

export const numberFormat = number =>
  new Intl.NumberFormat('en-US').format(number);

export const calcPercent = (curValue, sumValue, round = 0) => {
  if (typeof curValue !== 'number' || typeof sumValue !== 'number') {
    return '';
  }
  const value = +((curValue / sumValue) * 100).toFixed(round);
  return value;
};

export const calcTrend = (curValue, prevValue, round = 0) => {
  if (typeof curValue !== 'number' || typeof prevValue !== 'number') {
    return null;
  }
  if (prevValue === 0) return curValue;
  return +(((curValue - prevValue) / prevValue) * 100).toFixed(round) || 0;
};

export const round2 = number => Math.round(number * 100) / 100;

export const createFilterCountry = (arrFrom = [], arrTo) => {
  arrFrom.forEach(item => {
    if (item && item !== 'null') {
      arrTo.push({
        value: item,
        label: <FilterItemLocation item={item} />,
        findName: `${
          countryCodes.find(({ code }) => code === item)?.name
        } ${item}`,
        fullName: countryCodes.find(({ code }) => code === item).name
      });
    }
  });

  arrTo.sort((a, b) => {
    if (a.findName > b.findName) return 1;
    if (a.findName < b.findName) return -1;
    return 0;
  });
};

export const createFilterCountryWithStatus = (arrFrom = [], arrTo) => {
  arrFrom.forEach(item => {
    if (item.val && item.val !== 'null') {
      arrTo.push({
        value: item.val,
        label: <FilterItemLocation item={item.val} />,
        findName: `${countryCodes.find(({ code }) => code === item.val).name} ${
          item.val
        }`,
        fullName: countryCodes.find(({ code }) => code === item.val).name,
        status: item.status
      });
    }
  });

  arrTo.sort((a, b) => {
    if (a.findName > b.findName) return 1;
    if (a.findName < b.findName) return -1;
    return 0;
  });
};

export const createFilterSize = (arrFrom = [], arrTo) => {
  arrFrom.map(item => {
    if (item !== '-' || item !== 'NA') {
      arrTo.push({
        value: item,
        label: sizeToCompany(item)
      });
    } else {
      arrTo.unshift({
        value: item,
        label: item
      });
    }
    return '';
  });
};

const FAValues = {
  usingDnsfiltering: 'DNS Filtering',
  customDnsEnabled: 'Custom DNS',
  isNprUsing: 'Firewall',
  isDpcUsing: 'Device Posture Check',
  isUsingSwg: 'SWG',
  isUsingApp: 'ZTA applications'
};

export const createFilterFeatureAdoption = (arrFrom = [], arrTo) => {
  arrFrom.map(item => {
    if (item in FAValues) {
      arrTo.push({
        value: item,
        label: FAValues[item]
      });
    } else {
      arrTo.unshift({
        value: item,
        label: item
      });
    }
    // return '';
  });
};

export const createFilterStatus = (statusPars, filters) => {
  return filters
    ? filters.map(filter => ({
        value: filter,
        label: statusPars[filter]
      }))
    : [];
};

export const createFilterStatusUnderline = filters => {
  return filters
    ? filters.map(item => ({ value: item, label: underlineToSpace(item) }))
    : [];
};

export const getQuarter = date => {
  return Math.floor((date.getMonth() + 3) / 3);
};

export const parsQueryForSave = query => {
  if (query) {
    if (typeof query === 'object') {
      return query.map(item =>
        item.split('&').join('%26').split('+').join('%2B')
      );
    } else {
      return query.split('&').join('%26').split('+').join('%2B');
    }
  } else return '';
};

export const protocolsColor = {
  https: '#ed793b',
  http: '#5872de',
  ssh: '#4faf8d',
  rdp: '#dd6084',
  vnc: '#f3c91f'
};

export const statusColor = status => {
  const colors = {
    completed: '#1ecb85',
    allow: '#1ecb85',
    true: '#1ecb85',
    enable: '#1ecb85',
    ongoing: '#fd596f',
    postmortem: '#3a6ad1',
    resolved: '#1ecb85',
    deny: '#fd596f',
    false: '#fd596f',
    disable: '#fd596f',
    block: '#fd596f',
    scheduled: '#ffe654',
    in_progress: '#fd596f',

    active: '#1ecb85',
    inactive: '#fd596f',
    unknown: '#b3bac8',
    warning: '#ffe654'
  };
  const color = colors[status];
  if (color) {
    return color;
  }
  return '#b3bac8';
};

export const chooseStatusOnGoing = arrValues => {
  if (arrValues.includes('ongoing')) {
    return 'ongoing';
  } else if (arrValues.includes('scheduled')) {
    return 'scheduled';
  }
  return arrValues[0] || false;
};
export const chooseNetworkStatus = arrValues => {
  if (arrValues.includes('inactive')) {
    return 'inactive';
  } else if (arrValues.includes('active')) {
    return 'active';
  }
  return arrValues[0] || false;
};
export const cutTextforToltip = (name, length) => {
  if (name.length > length) {
    return `${name.slice(0, length)}...`;
  }
  return name;
};

export const recordType = ({ partnerType, customerType }) => {
  if (
    partnerType === '-' ||
    partnerType === undefined ||
    partnerType === null ||
    partnerType === 'NA'
  )
    return customerType;
  else return `${partnerType} (${customerType})`;
};

export const delProperties = (obj, names = []) => {
  const objForPars = { ...obj };
  names.forEach(name => {
    delete objForPars[name];
  });

  return objForPars;
};

export const toQueryParams = filter =>
  JSON.stringify(filter).split('+').join('%2B').split('&').join('%26');

export const replaceHistory = (
  filter,
  setEnabledRequest = () => {},
  history,
  mode,
  forHistory,
  changeFilter,
  tableConf
) => {
  if (mode === 'validation') {
    setEnabledRequest(false);
  }
  const query = `filter=${toQueryParams(forHistory ? forHistory : filter)}`;
  const tableQuery = `tableConf=${JSON.stringify(tableConf)}`;

  // A replace rewrites the same entry, so it keeps that entry's router state.
  // A push creates a new entry and carries the state only on region-switch
  // stay paths (the FF Assigned page's flag record), so a filter change
  // followed by a region switch still has the record to carry.
  if (mode === 'replace' || mode === 'validation') {
    history.replace(
      `${history.location.pathname}?${query}&changeFilter=${changeFilter}&${tableQuery}`,
      history.location.state
    );
  } else {
    history.push(
      `${history.location.pathname}?${query}&changeFilter=${changeFilter}&${tableQuery}`,
      isRegionSwitchStayPath(history.location.pathname)
        ? history.location.state
        : undefined
    );
  }
};

export const replaceHistoryCML = (
  direction,
  filter,
  setEnabledRequest = () => {},
  history,
  mode,
  forHistory,
  changeFilter,
  tableConf
) => {
  let query;
  const urlParams = new URLSearchParams(history.location.search);
  const jarvisRegion = urlParams.get('jarvisRegion') || 'US';
  if (mode === 'validation') {
    setEnabledRequest(false);
  }
  if (direction) {
    const newFilter = { ...filter, direction: direction };
    query = `filter=${toQueryParams(newFilter)}`;
  } else {
    query = `filter=${toQueryParams(filter)}`;
  }
  const tableQuery = `tableConf=${JSON.stringify(tableConf)}`;
  history.push(
    `${history.location.pathname}?${query}&jarvisRegion=${jarvisRegion}&changeFilter=${changeFilter}&${tableQuery}`
  );
};

export const parsConfigForHistory = config => {
  const resConfig = config.map(el => {
    return {
      field: el.field,
      show: el.show
    };
  });
  return resConfig;
};

export const reParsConfigForHistory = (
  currentConfig = [],
  configDefault = []
) => {
  return currentConfig.map(el => {
    const forResConfig = configDefault.find(item => item.field === el.field);
    return { ...forResConfig, ...el };
  });
};

export const moveIndex = (input, from, to) => {
  let numberOfDeletedElm = 1;
  const elm = input.splice(from, numberOfDeletedElm)[0];
  numberOfDeletedElm = 0;
  return input.splice(to, numberOfDeletedElm, elm);
};

export const paddingForMenuSettings = (tableConf, tableRef) => {
  const heightOptionInList = 32;
  const tolerance = 24;
  const tableHeight = tableRef.current
    ? tableRef.current.offsetHeight
    : undefined;
  const menuHeight = tableConf.length * heightOptionInList - tolerance;
  if (menuHeight > tableHeight) {
    return {
      paddingBottom: `${menuHeight - tableHeight}px`
    };
  }
};

export const checkingForExistenceOfOptions = (
  filter,
  setFilter,
  body,
  yesNoMode
) => {
  const keysFilter = Object.keys(body);
  let newFilterList = { ...filter };
  keysFilter.forEach(key => {
    if (newFilterList[key]) {
      typeof newFilterList[key] === 'string'
        ? (newFilterList[key] =
            body[key].find(val => {
              return String(val).toLowerCase() === !yesNoMode
                ? newFilterList[key].toLowerCase()
                : newFilterList[key] === 'Yes'
                ? 'true'
                : newFilterList[key] === 'No'
                ? 'false'
                : newFilterList[key];
            }) !== undefined
              ? newFilterList[key]
              : '')
        : (newFilterList[key] = newFilterList[key].filter(item =>
            body[key].find(val => val === item)
          ));
    }
  });
  if (JSON.stringify(newFilterList) !== JSON.stringify(filter)) {
    setFilter(newFilterList);
    return newFilterList;
  }
  return false;
};

export const changeIconDivice = (deviceType = '', osVersion = '') => {
  let iconName = '';
  switch (deviceType.toLowerCase()) {
    case 'windows':
    case 'win':
      iconName = 'windows';
      break;
    case 'ios':
    case 'mac':
      iconName = 'ios';
      break;
    case 'linux':
      iconName = osVersion.toLowerCase().includes('ubuntu')
        ? 'ubuntu'
        : 'linux';
      break;
    case 'android':
      iconName = 'android';
      break;
    default:
      break;
  }
  return iconName;
};

export const periodFormat = date => {
  if (!date) {
    date = { startDate: null, endDate: null };
  }
  const formatDate = date => moment(date, 'MM/DD/YYYY').format('YYYY/MM/DD');
  return date.startDate
    ? date.startDate !== date.endDate
      ? `${formatDate(date.startDate)}-${formatDate(date.endDate)}`
      : `${formatDate(date.startDate)}-${formatDate(
          moment(date.endDate).add(1, 'days')
        )}`
    : '*';
};

export const isFunction = functionToCheck =>
  functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';

export const isObjNotEmpty = obj =>
  obj && obj.constructor === Object && Object.entries(obj).length !== 0;

export const validationDefaultSetting = (
  defaultFilters,
  defaultNavigation,
  filter,
  filterBackend,
  setVisibleFilterSave,
  setChangeFilter,
  visibleFilterSave
) => {
  if (
    isEqual(
      delProperties(filter, Object.keys(defaultNavigation)),
      defaultFilters
    )
  ) {
    setVisibleFilterSave(false);
    setChangeFilter('Default');
  } else {
    const nameОfSelectedSettings = filterBackend.value.find(item => {
      return isEqual(
        delProperties(item.filters, Object.keys(defaultNavigation)),
        delProperties(filter, Object.keys(defaultNavigation))
      );
    });
    if (nameОfSelectedSettings) {
      setChangeFilter(nameОfSelectedSettings.name);
      setVisibleFilterSave(false);
    } else if (!visibleFilterSave) {
      let nameSetFilter = '';
      filterBackend.value.forEach(filterBack => {
        const filterForTest = filterBack.filters;
        const defaultNavigationKeys = Object.keys(defaultNavigation);

        const keysFilter = Object.keys(
          delProperties(filter, defaultNavigationKeys)
        ).sort();

        let triger = false;

        keysFilter.forEach(key => {
          let verifiableKeyName;
          if (listChangedNameFilers[filterBackend.key]) {
            verifiableKeyName = listChangedNameFilers[filterBackend.key].find(
              item => item.newName === key
            )
              ? listChangedNameFilers[filterBackend.key].find(
                  item => item.newName === key
                ).name
              : key;
          } else {
            verifiableKeyName = key;
          }

          if (!isEqual(filter[key], filterForTest[verifiableKeyName])) {
            if (
              !(
                isEqual(filter[key], defaultFilters[key]) &&
                !filterForTest[verifiableKeyName]
              )
            ) {
              triger = true;
            }
          }
        });
        if (!triger) {
          nameSetFilter = filterBack.name;
        }
      });
      if (nameSetFilter !== '') {
        setChangeFilter(nameSetFilter);
      } else {
        setVisibleFilterSave('button');
      }
    }
  }
};

export const isNull = val => val === null;

export const declOfNum = (number, titles) => {
  return number !== 1 ? titles[1] : titles[0];
};

export const clearOrDefaultFilters = (modeClearAll, defaultFilters) => {
  if (!modeClearAll) {
    return defaultFilters;
  }
  const arrFilterName = Object.keys(defaultFilters);
  const newValueFilters = { ...defaultFilters };

  arrFilterName.forEach(filterName => {
    const value = newValueFilters[filterName];
    newValueFilters[filterName] =
      typeof value === 'boolean'
        ? false
        : typeof value === 'string'
        ? ''
        : Array.isArray(value)
        ? []
        : { startDate: null, endDate: null };
  });
  return newValueFilters;
};

export const detectOS = () => {
  let os = 'Unknown OS';

  if (navigator.appVersion.indexOf('Win') !== -1) os = 'Windows';
  if (navigator.appVersion.indexOf('Mac') !== -1) os = 'MacOS';
  if (navigator.appVersion.indexOf('Linux') !== -1) os = 'Linux';

  return os;
};

export const renameMacOS = str => {
  return str.replace('macos', 'MacOS');
};

export const renameOS = str => {
  const osMap = {
    macos: 'MacOS',
    windows: 'Windows',
    linux: 'Linux'
  };

  return osMap[str];
};

export const isProdEnv = () => env.REACT_APP_ENV_NAME.includes('production');

export function copyToClipboard(str) {
  const t = document.createElement('textarea');
  t.style.height = 0;
  document.body.appendChild(t);
  t.value = str;
  t.select();
  document.execCommand('copy');
  document.body.removeChild(t);
}

export function noop() {}

export function capitalizeFirst(str) {
  return str.replace(/^./, match => match.toUpperCase());
}
export function capitalizeStatus(str) {
  const status = str.split(' ');
  const upStatus = status.map(val => {
    if (val.includes('('))
      return val.replace(val.charAt(1), val.charAt(1).toUpperCase());
    return val.replace(val.charAt(0), val.charAt(0).toUpperCase());
  });
  return upStatus.join(' ');
}

export const sizeToCompany = item => {
  if (item) {
    switch (item.toLowerCase()) {
      case 'small': {
        return 'Small (0 < 50)';
      }
      case 'smb': {
        return 'SMB (0 < 50)';
      }
      case 'medium': {
        return 'Medium (50 < 200)';
      }
      case 'large': {
        return 'Large (200 < 1000)';
      }
      case 'enterprise': {
        return 'Enterprise (1000+)';
      }

      default:
        return item;
    }
  }

  return 'NA';
};

export const filterForArrValues = (data, properties, valueForFilter) => {
  const arr = [...data];

  return arr.filter(item => {
    let trigger = false;
    properties.length > 0
      ? properties.forEach(property => {
          if (
            item[property]?.toLowerCase().includes(valueForFilter.toLowerCase())
          ) {
            trigger = true;
          }
        })
      : (trigger = item.toLowerCase().includes(valueForFilter.toLowerCase()));
    return trigger;
  });
};

export const getBeaconStatus = async (
  id,
  REQ_BODY,
  cancelled,
  setLoader = () => {},
  setIsErrorStatus = () => {}
) => {
  let beaconStatus = false;
  await postRequest('/cloud/management/beacon/status', REQ_BODY)
    .then(res => {
      if (!cancelled) {
        if (!isEmpty(res.body)) {
          beaconStatus = res.body;
        } else beaconStatus = false;
      }
    })
    .catch(err => {
      if (!cancelled) {
        console.log(err);
        setLoader(false);
        setIsErrorStatus(true);
      }
    })
    .finally(() => {
      return beaconStatus;
    });

  return beaconStatus;
};

export const colorList = [
  '#ed793b',
  '#5872de',
  '#4faf8d',
  '#f3cf3a',
  '#e46086',
  '#6bb9d7',
  '#c2375e',
  '#e51086',
  '#b17776',
  '#6cb691'
];

export const semverGreaterThan = (versionA, versionB) => {
  if (versionA && versionA) {
    const versionsA = versionA.split(/\./g).join('');
    const versionsB = versionB.split(/\./g).join('');

    const a = Number(versionsA);
    const b = Number(versionsB);

    // eslint-disable-next-line no-continue
    if (a === b) {
      return false;
    }
    // eslint-disable-next-line no-restricted-globals
    return a !== b;
  } else return false;
};

export function getOriginalTableSettingsListItems(tableConfig) {
  const newList = [...tableConfig];
  let count = 0;
  newList.forEach(item => {
    if (item.show) {
      count++;
    }
  });
  if (count <= 5) {
    newList.map(item => {
      if (item.show) {
        item.checkboxProps = { disabled: true };
      }
    });
  } else if (count === 6) {
    newList.map(item => {
      item.checkboxProps = { disabled: false };
    });
  }

  return newList.slice(1, -1).map(item => ({
    checkboxProps: item.checkboxProps,
    name: item.headerName,
    selected: item.show
  }));
}

export function columnSortHandler(array, from, to) {
  const newArray = [...array].slice(1);
  const startIndex = from < 0 ? array.length + from : from;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = to < 0 ? array.length + to : to;

    const [item] = newArray.splice(from, 1);
    newArray.splice(endIndex, 0, item);
  }

  return [array[0], ...newArray];
}

export const onChangeExportButton = (exportConfig, changeOptions) => {
  const createREQ_BODY = changeOptions => {
    let REQ_BODY = {
      fieldsToExport: '*'
    };
    let arrOptions = [];
    changeOptions.forEach(item => {
      const exportValues = item.valuesExport || item.fieldsToExport;
      if (item.show && exportValues) {
        exportValues.forEach(value => {
          arrOptions.push(value);
        });
      }
    });

    REQ_BODY = { fieldsToExport: arrOptions };

    return REQ_BODY;
  };

  const exportFiles = exportConfig => {
    const getExport = (url, REQ_BODY) => {
      const api = getExportInstance();
      return new Promise((resolve, reject) => {
        const exportMethod = !REQ_BODY ? api.get(url) : api.post(url, REQ_BODY);
        exportMethod
          .then(res => {
            resolve(res);
          })
          .catch(err => reject(err));
      });
    };

    const REQ_BODY = changeOptions ? createREQ_BODY(changeOptions) : undefined;
    getExport(exportConfig.exportUrl, REQ_BODY)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = `${exportConfig.exportName}${moment().format(
          'YYYY_MM_DD-HH_MM'
        )}.${exportConfig.exportFormat}`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        console.log(err);
      });
  };

  exportFiles(exportConfig);
};

export const onClickCompanyInCell = (cell, history, url) => {
  if (cell.field === 'companyName') {
    history.push(`${url}/${cell.row.customerId}/general`);
  }
};

export const enableDBAccess = async row => {
  const url = '/customer/platform/team/enable-db-access';
  const body = { customerId: row.customerId, userEmail: row.email };
  await putRequest(url, body)
    .then(() => {
      showNotif({
        message: 'Database access enabled successfully',
        kind: 'success',
        dismissAfter: 6000,
        type: 'alert'
      });
    })
    .catch(err => {
      showNotif({
        message: err.message,
        kind: 'error',
        dismissAfter: 6000,
        type: 'alert'
      });
    });
};

export function getRowHeight({ model }) {
  const rowsNumber = model.dpc?.failed?.length;
  return rowsNumber > 2 ? rowsNumber * 29 : null;
}

const linkOpen = link => {
  return window.open(link, '_blank', 'noopener,noreferrer');
};

const createAgentLink = (implicitToken, customerId) => {
  let link;
  const domain = getJarvisDomain();
  const os = detectOS();
  switch (os) {
    case 'MacOS':
      link = `perimeter81://${domain}/macos/callback?id_token=${implicitToken}&tenant_id=${customerId}&tokenType=implicitToken`;
      break;
    case 'Windows':
      link = `perimeter81://${domain}/callback?id_token=${implicitToken}&tenant_id=${customerId}&tokenType=implicitToken`;
      break;
    case 'Linux':
      {
        const linuxDomain = domain.split('.').reverse().join('.');
        link = `${linuxDomain}.linux://callback?id_token=${implicitToken}&tenant_id=${customerId}&tokenType=implicitToken`;
      }
      break;
  }
  return link;
};

export const handleAgent = (email, customerId) => {
  const REQ_BODY = {
    customerId: customerId,
    userEmail: email,
    rawToken: true
  };

  postRequest('/customer/platform/team/supportlink', REQ_BODY)
    .then(res => {
      res.body.implicitToken &&
        linkOpen(createAgentLink(res.body.implicitToken, customerId));
    })
    .catch(err => {
      console.log(err);
      showNotif({
        message: 'Error in access request',
        kind: 'error',
        dismissAfter: 10000,
        type: 'alert'
      });
    });
};

export const handlePlatform = (email, customerId) => {
  const REQ_BODY = {
    customerId: customerId,
    userEmail: email
  };
  postRequest('/customer/platform/team/supportlink', REQ_BODY)
    .then(res => {
      res.body.link && linkOpen(res.body.link);
    })
    .catch(err => {
      console.log(err);
      showNotif({
        message: 'Error in access request',
        kind: 'error',
        dismissAfter: 10000,
        type: 'alert'
      });
    });
};

export const getJarvisDomain = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const jarvisRegion = urlParams.get('jarvisRegion') || 'US';
  return p81AppDomains[jarvisRegion];
};
